import { useGetThemeName } from "../../../libs/hooks/useGetThemeName";
import { GettingStartedStoreAccess } from "../../../libs/store";
import { Link, Text } from "@shopify/polaris";

export function VerifyImplementationText() {
  const chosenThemeId = GettingStartedStoreAccess.useChosenThemeId();

  const getThemeName = useGetThemeName();
  const chosenThemeName = getThemeName(chosenThemeId);

  const displayVerifyImplementationText = GettingStartedStoreAccess.useDisplayVerifyImplementationText();

  if (!displayVerifyImplementationText) {
    return;
  }

  return (
    <Text as="span" variant="bodySm" color="critical">
      {`We couldn't find the Smartrr app block on ${chosenThemeName}.`}{" "}
      <Link url="https://help.smartrr.com/docs/getting-started/implementation/installing-smartrr-on-a-shopify-2.0-theme-automatic-install">
        View installation guide
      </Link>
    </Text>
  );
}
